/**
 * Rewards Summary Service - Get all required data
 *
 * @memberof RewardsSummary
 */
import {Injectable, NgZone} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {BehaviorSubject} from 'rxjs';
import {ParamService} from './param.service';
import {v4 as uuidv4} from 'uuid';
import {environment} from './../../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class RewardsSummaryService {
    public summaryTimeValue = window['AB']['rewardSummaryTime']; // this is the time for summary to take from local storage in miliseconds
    public AB = window['AB'];
    public SWY = window['SWY'];
    private rewardsPointSource = new BehaviorSubject<any>('');
    public currentRewardsPoints = this.rewardsPointSource.asObservable();
    public $initRewardScorecard = new BehaviorSubject(false);
    public $initPointScorecard = new BehaviorSubject(null);
    public $updateGalleryDetails = new BehaviorSubject(null);
    public $refreshCashRewardSection = new BehaviorSubject(false);
    public $clipResponseDone = new BehaviorSubject(false);
    hideGallerySource = new BehaviorSubject<boolean>(false);
    banner = '';

    public constructor(private _http: HttpClient, zone: NgZone, private paramService: ParamService) {
        this.banner = this.paramService.banner
        if (window && window['AB'] && window['AB'].COMMON && window['AB'].COMMON.authorize()) {
            window['AB'].ucaRewardsTrigger = false;
            // this.getRemoteData();
        } else {
            this.rewardsPointSource.next({});
        }
        window['rewardSummaryServiceRef'] = {
            zone: zone,
            service: this
        };
    }
    getLocationHref() {
        return window.location.href;
    }

    getLocationHost() {
        return window.location.host;
    }
    getApplicationDomainURL() {
        let domain;
        if (this.getLocationHref().indexOf('local') > 0) {
            domain = 'https://www-qa1.' + this.banner + '.com';
        } else {
            domain = 'https://' + this.getLocationHost();
        }
        return domain;
    }

    getMobileApplicationDomainURL(environment, banner) {
        let domain;
        let currentBanner = this.banner;
        if (window.location.href.indexOf('prod') > 0) {
            domain = 'https://www.' + banner + '.com';
        } else {
            domain = 'https://www-' + environment + '.' + banner + '.com';
        }
        return domain;
    }

    getEnvironment() {
        let appEnvironment;
        if (window.location.origin.indexOf('qa1') > 0 || window.location.origin.indexOf('qa2') > 0 || window.location.origin.indexOf('qa3') > 0 || window.location.origin.indexOf('stage') > 0) {
            appEnvironment = window.location.host.split('-')[1].split('.')[0];
        } else if (window.location.origin.indexOf('local') > 0) {
            appEnvironment = 'qa1';
        } else {
            appEnvironment = 'prod';
        }
        return appEnvironment;
    }
    public replaceHeaderBanner(header) {
        if (header) {
            if (header['banner']) {
                header['banner'] = header['banner'].replace(/\{banner\}/g, this.banner);
            }
            if (header['x-swy_banner']) {
                header['x-swy_banner'] = header['x-swy_banner'].replace(/\{banner\}/g, this.banner);
            }
            if (header['X-SWY_BANNER']) {
                header['X-SWY_BANNER'] = header['X-SWY_BANNER'].replace(/\{banner\}/g, this.banner);
            }
            if (header['x-swy-banner']) {
                header['x-swy-banner'] = header['x-swy-banner'].replace(/\{banner\}/g, this.banner);
            }
            if (header['X-Swy_banner']) {
                header['X-Swy_banner'] = header['X-Swy_banner'].replace(/\{banner\}/g, this.banner);
            }

        }
    }
    parseJwt(jwtToken) {
        const base64Url = jwtToken.split('.')[1];
        const base64 = base64Url.replace('-', '+').replace('_', '/');
        return JSON.parse(window.atob(base64));
    }
    getUserClaims(user) {
        const oktaToken = this.parseJwt(user.SWY_SHOP_TOKEN);
        const userClaims = {
            aln: oktaToken['aln'] ? oktaToken['aln'] : undefined,
            hid: oktaToken['hid'] ? oktaToken['hid'] : undefined,
            zip: oktaToken['zip'] ? oktaToken['zip'] : undefined,
            gid: oktaToken['gid'] ? oktaToken['gid'] : undefined,
            uuid: oktaToken['uuid'] ? oktaToken['uuid'] : undefined,
            exp: oktaToken['exp'] ? oktaToken['exp'] : undefined,
            firstname: oktaToken['fnm'] ? oktaToken['fnm'] : undefined,
            lastname: oktaToken['lnm'] ? oktaToken['lnm'] : undefined
        };
        return userClaims;
    }

    checkMobileTokenValidity(user) {
        const currentDate = new Date();
        const userClaims = this.getUserClaims(user);
        const timestampInSeconds = userClaims['exp'] + '000';
        const expiryDate = new Date(Number(timestampInSeconds));
        if (user && user['token'] && (expiryDate > currentDate)) {
            return true;
        } else {
            return false;
        }
    }

    public getData(): Observable<any> {
        return this.currentRewardsPoints;
    }

    public setData(rewardsPointsData) {
        this.rewardsPointSource.next(rewardsPointsData);
    }

    /**
     * This metod is use to Load the Account for the J4U --> Rewards and J4U --> Rewards-Detail pages.
     * @param isCallNewGetRewardsSummary
     */
    public getRemoteData(userInfo, currentEnv, programType) {
        const isOcrpXapiRewardsFlagEnabled = true;
        if (isOcrpXapiRewardsFlagEnabled) {
            this.callNewRewardsCall(userInfo, currentEnv, programType);
        } else {
            this.callLegacyRewardsCall();
        }
    }

    private callLegacyRewardsCall() {
        const rewardsSummaryUrl = this.AB.emrbGetRewardSummary;
        const httpOptions = {headers: new HttpHeaders(this.AB.emrbRewardsHeader)};

        this._http.get(rewardsSummaryUrl, httpOptions).subscribe((data) => {
            this.rewardsPointSource.next(data);
            if (typeof window['AB'].UCAREWARDS === 'object' && typeof window['AB'].UCAREWARDS.renderRewardPoints === 'function') {
                window['AB'].UCAREWARDS.renderRewardPoints(data);
            }
        }, error => {
            this.rewardsPointSource.next({});
            if (typeof window['AB'].UCAREWARDS === 'object' && typeof window['AB'].UCAREWARDS.renderRewardsError === 'function') {
                window['AB'].UCAREWARDS.renderRewardsError(error);
            }
        });
    }

    private callNewRewardsCall(userInfo, currentEnvironment, programType) {
        const jwtClaims = this.getUserClaims(userInfo);
        const body = {
            hhid: jwtClaims.hid,
            programType: [programType]
        };
        let scoreCardURL = this.getApplicationDomainURL() + environment[currentEnvironment].rewardsLookupConfig.getRewardsScoreCard;
        scoreCardURL = this.replaceParameter(scoreCardURL, userInfo);
        const headerOBJ = environment[currentEnvironment].rewardsLookupConfig.xAPIOcrpRewardsHttpOptions;
        this.replaceHeaderBanner(headerOBJ);
        const options = {
            headers: {
                ...headerOBJ,
                'Authorization': `Bearer ${userInfo.SWY_SHOP_TOKEN}`,
                'x-swy-correlation-id': uuidv4()
            }
        };
        this._http.post<any>(scoreCardURL, body, options).subscribe({
            next: data => {
                // Map the Date to rewards --> rewardPoints, rewardsExpire, rewardsAvailable
                const rewardsData = {
                    rewards: {
                        // dollar
                        rewardPoints: 0,
                        // willExpire
                        rewardsExpire: 0,
                        // rewardBalance
                        rewardsAvailable: 0,
                        // rewardsExpireDate
                        rewardsExpireDate: new Date().toLocaleDateString()
                    }
                };

                if (data && data.scorecards && data.scorecards.length > 0) {
                    for (let i = 0; i < data.scorecards.length; i++) {
                        const scoreCard = data.scorecards[i];
                        if (scoreCard.programType === 'BASEPOINTS') {
                            rewardsData.rewards.rewardPoints = data.scorecards[i].dollar;
                            rewardsData.rewards.rewardsExpire = data.scorecards[i].willExpire;
                            rewardsData.rewards.rewardsAvailable = data.scorecards[i].rewardBalance;
                            rewardsData.rewards.rewardsExpireDate = data.scorecards[i].rewards[2].validityEndDate;
                        }
                    }
                }

                this.rewardsPointSource.next(rewardsData);
                if (typeof this.AB.UCAREWARDS === 'object' && typeof this.AB.UCAREWARDS.renderRewardPoints === 'function') {
                    this.AB.UCAREWARDS.renderRewardPoints(rewardsData);
                }
            },
            error: error => {
                this.rewardsPointSource.next({});
                if (typeof this.AB.UCAREWARDS === 'object' && typeof this.AB.UCAREWARDS.renderRewardsError === 'function') {
                    this.AB.UCAREWARDS.renderRewardsError(error);
                }
            }
        });
    }

    public checkSummaryTime(abRewardsSummaryLS) {
        return abRewardsSummaryLS && ((Date.now() - JSON.parse(abRewardsSummaryLS).savedTime) <= this.summaryTimeValue);  // check for summary localStorage time and now difference to be maximum the declared number
    }

    public useOrDeleteSummary() {
        let result = false;

        const abRewardsSummaryLS = localStorage.abRewardsSummary;
        if (this.checkSummaryTime(abRewardsSummaryLS)) {
            result = true;
        } else if (abRewardsSummaryLS) {
            localStorage.removeItem('abRewardsSummary');
            result = false;
        }
        return result;
    }
    replaceParameter(url, userInfo) {
        return url.replace('{customerId}', userInfo.customerId);
    }
    public getRewardsUCAProfile(currentEnvironment, userInfo) {
        let url = environment[currentEnvironment].rewardsLookupConfig.getprofileAddressPath;
        url = url.replace('{customerId}', userInfo.UUID);
        const ucaAPIWithCustomerId = this.getApplicationDomainURL() + url;
        const headerObj = environment[currentEnvironment].rewardsLookupConfig.ucaHttpOptionsGetProfile;

        this.replaceHeaderBanner(headerObj);
        const options = {
            headers: {
                ...headerObj,
                'Authorization': `Bearer ${userInfo.SWY_SHOP_TOKEN}`,
                'x-swy-correlation-id': uuidv4()
            }
        };
        return this._http.get(ucaAPIWithCustomerId, options);
    }

    public getRewardsProfileAddress(data, userInfo, currentEnvironment) {
        const patchHeaders = environment[currentEnvironment].rewardsLookupConfig.ucaHttpOptionsGetProfile;
        this.replaceHeaderBanner(patchHeaders);
        patchHeaders['Content-Type'] = 'application/vnd.safeway.v2.merge-patch+json';
        let url = this.getApplicationDomainURL() + environment[currentEnvironment].rewardsLookupConfig.getprofileAddressPath;
        const jwtClaims = this.getUserClaims(userInfo);
        url = url.replace('{customerId}', jwtClaims.gid);
        const options = {
            headers: {
                ...patchHeaders,
                'Authorization': `Bearer ${userInfo.SWY_SHOP_TOKEN}`,
                'x-swy-correlation-id': uuidv4()
            },
            body: JSON.stringify(data),
        };
        return this._http.patch(url, options);
    }

    public updateBirthdayUCA(data, userInfo, currentEnvironment) {
        const patchHeaders = environment[currentEnvironment].rewardsLookupConfig.ucaHttpOptionsUpdateProfile;
        this.replaceHeaderBanner(patchHeaders);
        let url = this.getApplicationDomainURL() + environment[currentEnvironment].rewardsLookupConfig.getprofileAddressPath;
        const jwtClaims = this.getUserClaims(userInfo);
        url = url.replace('{customerId}', jwtClaims.uuid);
        patchHeaders['Authorization'] = `Bearer ${userInfo.SWY_SHOP_TOKEN}`;
        patchHeaders['x-swy-correlation-id'] = uuidv4();
        return this._http.patch(url, JSON.stringify(data), {headers: patchHeaders});
    }

    public getRewardsScoreCard(currentEnvironment, proramType, userInfo) {
        const jwtClaims = this.getUserClaims(userInfo);
        const body = {
            hhid: jwtClaims.hid,
            programType: [proramType]
        };
        let scoreCardURL = this.getApplicationDomainURL() + environment[currentEnvironment].rewardsLookupConfig.getRewardsScoreCard;
        scoreCardURL = this.replaceParameter(scoreCardURL, userInfo);
        const headerOBJ = environment[currentEnvironment].rewardsLookupConfig.xAPIOcrpRewardsHttpOptions;
        this.replaceHeaderBanner(headerOBJ);
        const options = {
            headers: {
                ...headerOBJ,
                'Authorization': `Bearer ${userInfo.SWY_SHOP_TOKEN}`,
                'x-swy-correlation-id': uuidv4()
            }
        };
        return this._http.post<any>(scoreCardURL, body, options);
    }

    public getRewardsScoreCardV3(currentEnvironment, programType, userInfo) {
        const jwtClaims = this.getUserClaims(userInfo);
        const body = {
            hhid: jwtClaims.hid,
            programType: [programType]
        }
        let scoreCardURL = this.getApplicationDomainURL() + environment[currentEnvironment].rewardsLookupConfig.getRewardsScoreCard;
        scoreCardURL = this.replaceParameter(scoreCardURL, userInfo);

        const httpOptions = environment[currentEnvironment].rewardsLookupConfig.xAPIOcrpRewardsHttpOptionsV3;

        const options = {
            headers: {
                ...httpOptions,
                'Authorization': `Bearer ${userInfo.SWY_SHOP_TOKEN}`,
                'x-swy-correlation-id': uuidv4()
            }
        };
        return this._http.post(scoreCardURL, body, options);
    }

    public getFreshpassSubscription(currentEnvironment, userInfo) {
        const url = environment[currentEnvironment].freshpassLookupConfig.freshpassURL;
        const subscriptionHeader = environment[currentEnvironment].freshpassLookupConfig.freshpassHeaders;
        this.replaceHeaderBanner(subscriptionHeader);
        const options = {
            headers: {
                ...subscriptionHeader,
                'Authorization': `Bearer ${userInfo.SWY_SHOP_TOKEN}`,
                'x-swy-correlation-id': uuidv4()
            }
        };
        const subscriptionRrl = this.getApplicationDomainURL() + url.replace('{gid}', userInfo.customerId);

        return this._http.get(subscriptionRrl, options);
    }

    public getFreshpassTiers(currentEnvironment, userInfo) {
        const url = environment[currentEnvironment].freshpassLookupConfig.freshpassTierStatus;
        const subscriptionHeader = environment[currentEnvironment].freshpassLookupConfig.tierStatusHeaders;
        this.replaceHeaderBanner(subscriptionHeader);
        let currentTime = new Date();
        const jwtClaims = this.getUserClaims(userInfo);
        const options = {
            headers: {
                ...subscriptionHeader,
                'Authorization': `Bearer ${userInfo.SWY_SHOP_TOKEN}`,
                'x-swy-correlation-id': uuidv4(),
                'UUID': jwtClaims.uuid,
                'x-swy-date': currentTime.toString()
            }
        };
        const subscriptionRrl = this.getApplicationDomainURL() + url;

        return this._http.get(subscriptionRrl, options);
    }

    public getBirthDayXFJSON(currentEnvironment) {
        let url;
        url = this.getApplicationDomainURL() + environment[currentEnvironment].rewardsLookupConfig.birthDayModUnitXF;
        return this._http.get(url);
    }

    public getPointsScoreCardData(currentEnvironment, userInfo) {

        const programType = 'BASEPOINTS';
        let rwdObj = {
            rewards: {
                balance: 0,
                dollarDiscount: 0,
                points: null,
                autoRewardsPoints:0,
                willExpire:0,
                isUserHasRewards: false
            }
        };

        let profileObj = {
            freshPass: {
                // Fresh Pass check
                isActive: false
            }
        };
        let rewardsResponseObj: any;

        this.getRewardsScoreCardV3(currentEnvironment, programType, userInfo).subscribe((data: any) => {
            if (data && data.scorecards && data.scorecards.length > 0) {
                // Get the BASEPOINT scorecard
                let scoreCard = data.scorecards.find(scorecard => {
                    return scorecard.programType === 'BASEPOINTS';
                });
                if (scoreCard) {
                    rwdObj.rewards.balance = ((scoreCard.balance < 0) ? 0 : scoreCard.balance);
                    rwdObj.rewards.points = scoreCard.points;
                    rwdObj.rewards.dollarDiscount = ((scoreCard.dollarDiscount < 0) ? 0 : scoreCard.dollarDiscount);
                    rwdObj.rewards.autoRewardsPoints = ((scoreCard.autoRewardsPoints < 0) ? 0 : scoreCard.autoRewardsPoints);
                    rwdObj.rewards.willExpire = ((scoreCard.willExpire < 0) ? 0 : scoreCard.willExpire);
                    rwdObj.rewards.isUserHasRewards = true;
                }
                this.getFreshpassSubscription(currentEnvironment, userInfo).subscribe((data: any) => {
                    if (data && data.Data) {
                        profileObj.freshPass.isActive = (data.Data.subscriptionStatus === 'ACTIVE' || data.Data.subscriptionStatus === 'TRIAL' || data.Data.subscriptionStatus === 'PENDING_CANCELLATION');
                    }
                }, error => {
                    profileObj.freshPass.isActive = false;

                })
            } else {
                profileObj.freshPass.isActive = false;
            }
            rewardsResponseObj = rwdObj;
        }, error => {
            profileObj.freshPass.isActive = false;
            rewardsResponseObj = rwdObj;

        })
        return rewardsResponseObj;
    }

    getStoreIdForUserType(userInfo) {
        if (userInfo && userInfo.storeId) {
            return userInfo.storeId;
        } else if(userInfo && userInfo.shopStoreId)  {
            return userInfo.shopStoreId;
        } else {
            return  userInfo.j4uStoreId
        }

    }
}
